var map = {
	"./FEEDBACK/entries/1200px-dark.png": 87731,
	"./FEEDBACK/entries/1200px-light.png": 51500,
	"./FEEDBACK/entries/1440px-dark.png": 35180,
	"./FEEDBACK/entries/1440px-light.png": 92337,
	"./FEEDBACK/entries/1680px-dark.png": 96399,
	"./FEEDBACK/entries/1680px-light.png": 2623,
	"./FEEDBACK/entries/1920px-dark.png": 86700,
	"./FEEDBACK/entries/1920px-light.png": 30274,
	"./FEEDBACK/overview/1200px-dark.png": 44484,
	"./FEEDBACK/overview/1200px-light.png": 39767,
	"./FEEDBACK/overview/1440px-dark.png": 76603,
	"./FEEDBACK/overview/1440px-light.png": 45917,
	"./FEEDBACK/overview/1680px-dark.png": 58176,
	"./FEEDBACK/overview/1680px-light.png": 69287,
	"./FEEDBACK/overview/1920px-dark.png": 43005,
	"./FEEDBACK/overview/1920px-light.png": 28949,
	"./SURVEY/entries/1200px-dark.png": 5622,
	"./SURVEY/entries/1200px-light.png": 61009,
	"./SURVEY/entries/1440px-dark.png": 70475,
	"./SURVEY/entries/1440px-light.png": 57045,
	"./SURVEY/entries/1680px-dark.png": 83351,
	"./SURVEY/entries/1680px-light.png": 48923,
	"./SURVEY/entries/1920px-dark.png": 27959,
	"./SURVEY/entries/1920px-light.png": 57188,
	"./SURVEY/overview/1200px-dark.png": 31027,
	"./SURVEY/overview/1200px-light.png": 11619,
	"./SURVEY/overview/1440px-dark.png": 97201,
	"./SURVEY/overview/1440px-light.png": 75010,
	"./SURVEY/overview/1680px-dark.png": 15164,
	"./SURVEY/overview/1680px-light.png": 83444,
	"./SURVEY/overview/1920px-dark.png": 18282,
	"./SURVEY/overview/1920px-light.png": 49480,
	"./SURVEY/reports/1200px-dark.png": 48113,
	"./SURVEY/reports/1200px-light.png": 79420,
	"./SURVEY/reports/1440px-dark.png": 78629,
	"./SURVEY/reports/1440px-light.png": 82872,
	"./SURVEY/reports/1680px-dark.png": 5555,
	"./SURVEY/reports/1680px-light.png": 66425,
	"./SURVEY/reports/1920px-dark.png": 92893,
	"./SURVEY/reports/1920px-light.png": 13904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71095;